import { render } from "./FbnPreview.vue?vue&type=template&id=285a3e74"
import script from "./FbnPreview.vue?vue&type=script&lang=js"
export * from "./FbnPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__